import React from 'react'
import { Well } from '@pushly/aqe/lib/components'
import { Flex, Form, Select } from 'antd'
import { CatalogItemType } from '@pushly/models/lib/enums'
import { JourneyType, TriggerType } from '@pushly/models/lib/enums/journeys'
import { buildTriggerOptions } from '../../trigger-config'

export interface ITriggerSectionProps {
    trigger?: {
        configuration?: { type?: TriggerType; params?: Record<string, unknown> }
    }
    journeyType: JourneyType
    hasAbandonedViewAccess: boolean
    hasSavedItemsAccess: boolean
    domainItemType?: CatalogItemType
    onChange: (next: TriggerType) => void
    disabled?: boolean
}

const TRIGGER_ID = 'jc-trigger-select'

export const TriggerSection: React.FC<ITriggerSectionProps> = React.memo(
    ({
        trigger,
        journeyType,
        hasAbandonedViewAccess,
        hasSavedItemsAccess,
        onChange,
        domainItemType,
        disabled,
    }) => {
        const cfg = (trigger?.configuration ?? {}) as { type?: TriggerType; params?: Record<string, unknown> }
        const triggerType = cfg?.type as TriggerType | undefined
        const rawItemType = (cfg?.params as any)?.item_type
        const itemType = (() => {
            // Prefer item type set on journey trigger
            if (rawItemType) {
                const rawStr = String(rawItemType).toLowerCase()
                const enumValues = Object.values(CatalogItemType) as Array<string>
                const direct = enumValues.find((v) => String(v).toLowerCase() === rawStr)
                if (direct) return direct as unknown as CatalogItemType
                const map: Record<string, CatalogItemType | undefined> = {
                    product: CatalogItemType.PRODUCT,
                    event: CatalogItemType.TICKETED_EVENT,
                    recipe: CatalogItemType.RECIPE,
                }
                return map[rawStr] ?? domainItemType ?? CatalogItemType.PRODUCT
            }

            // 2) Fallback to domain item type, if provided
            if (domainItemType) return domainItemType

            // 3) Final fallback to PRODUCT
            return CatalogItemType.PRODUCT
        })()

        const options = buildTriggerOptions(
            itemType,
            { hasAbandonedViewAccess, hasSavedItemsAccess },
            journeyType,
        )

        return (
            <Well variant="ghost" title="Trigger" footerMode="hidden" padding="none" className="entry-cap-well">
                <Flex align="center" gap={8}>
                    <label htmlFor={TRIGGER_ID}>Subscribers enter this journey after</label>
                    <Select
                        id={TRIGGER_ID}
                        className="journey-trigger-editor-type-selection"
                        classNames={{
                            content: 'journey-trigger-editor-type-dropdown',
                        }}
                        size="small"
                        placeholder="Select a journey trigger"
                        value={triggerType}
                        onChange={onChange as any}
                        style={{ minWidth: 250 }}
                        popupMatchSelectWidth={false}
                        popupStyle={{ minWidth: 300 }}
                        disabled={disabled}
                        options={options.map((o) => ({
                            value: o.value,
                            label: o.label,
                        }))}
                    />
                </Flex>
            </Well>
        )
    },
)

export default TriggerSection
